<template lang="pug">
  section.container.container--login
    h1.login__header(
      :class="$mq === 'mobile' ? 'h2' : 'h4'"
    ) Log In
    .login__main(ref="formWrapper")
      .row
        .small-12.medium-5.column
          .login__column
            slot
        .small-12.medium-2.column.login__divider
          .login__divider__line
        .small-12.medium-5.column.login__alt-container(
          data-dtk-shop="{{shop.permanent_domain}"
        )
          .login__column
            .oxi-social-login
            .login__button.login__button--register
              p.login__button-label Need an Account?
              a.u-link.u-link--bold(href="/account/register") Sign Up
</template>

<script>
  import FormValidation from 'scripts/helpers/formValidation.js';

  import Icon from 'scripts/components/basic/Icon.vue'

  // Note: AccountRegister extends this component
  export default {
    name: 'AccountLogin',
    components: { Icon },
    mounted () {
      const requiredFields = this.$refs.formWrapper.querySelectorAll('input[required]');
      FormValidation.addFormValidation([...requiredFields]);
    }
  }
</script>

<style lang="scss">
  $max-width-main-container: 1000px;
  $columns-extra-spacing-desktop: 25px;
  $form-input-margin: 12px;
  $button-padding: 14px;
  $divider-spacing-mobile: 46px;
  $divider-text-position-tablet: 50%; // From bottom

  .container--login {
    margin-bottom: 100px;
    margin-top: $grid-gutter * 2;

    @include tablet-up {
      margin-bottom: 150px;
      margin-top: 56px;
    }
  }

  .login {
    // Wraps row to avoid conflicting margins
    &__main {
      max-width: $max-width-main-container;
      margin-left: auto;
      margin-right: auto;
      margin-top: 20px;
      margin-bottom: 108px;

      @include tablet-up {
        margin-top: 50px;
        margin-bottom: 0;
      }
    }

    &__header {
      margin: auto;
      max-width: 950px;
      font-size: rem(23);
      line-height: rem(28);
      color: $color-indigo;

      @include tablet-up {
        font-size: rem(35);
        line-height: rem(44);
      }
    }

    &__column {
      // Extra spacing between columns for desktop
      @include desktop-up {
        &:first-child {
          margin-right: $columns-extra-spacing-desktop;
        }

        &:last-child {
          margin-left: $columns-extra-spacing-desktop;
        }
      }
    }

    &__divider {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &__line {
        // Horizontal line
        background-color: $border--lightest;
        width: 100%;
        height: 1px;
        margin-top: $divider-spacing-mobile;
        margin-bottom: $divider-spacing-mobile;

        // Vertical line
        @include tablet-up {
          width: 1px;
          height: 100%;
          margin-top: 0;
          margin-bottom: 0;
        }
      }

      // Divider text ("OR")
      &::after {
        // Horizontal position
        content: "OR";
        position: absolute;
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
        letter-spacing: 3px;
        padding: 18px;
        background-color: $color-white;
        left: 50%;
        transform: translateX(-50%);

        // Vertical position
        @include tablet-up {
          top: $divider-text-position-tablet;
          left: unset;
          transform: translateY(-50%);
        }
      }
    }

    &__alt-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    // Form spacing (slotted in)
    &--input {
      margin-bottom: $form-input-margin;

      &-link {
        display: inline-block;
        margin-top: $form-input-margin * 2;
        font-family: $font-gibson;
      }

      &-submit {
        display: block;
        margin-top: $form-input-margin * 2.75;
      }
    }

    &__button {
      width: 100%;
      border: 1px solid $border--lightest;
      padding: $button-padding;

      &:not(:last-child) {
        margin-bottom: 24px;
      }

      &--social {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color 0.3s ease;

        > .icon {
          position: absolute;
          left: $button-padding;
        }

        &:hover, &:active, &:focus {
          border-color: $border--input--focus;
        }
      }

      &--register {
        text-align: center;
        padding: $button-padding + 6;

        p {
          margin-top: 0;
          margin-bottom: 4px;
        }
      }
    }
  }

  .input-submit-wrapper--login {
    margin-top: 35px;
  }

  .input-submit-wrapper--forgotpw {
    margin-top: 15px;
  }

  .login__button-label {
    font-family: $font-gibson;
  }

  .login-with-amazon {
    margin-left: 25px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;

    // Amazon styles
    background: linear-gradient(to bottom,#f7dfa5,#f0c14b);
    border-color: #a88734 #9c7e31 #846a29;
    color: #111;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    cursor: pointer;
    display: inline-block;
    padding: 0;
    text-align: center;
    text-decoration: none !important;
    font-family: Arial, sans-serif;
    font-size: 13px;
    line-height: 29px;
    vertical-align: middle;
  }
</style>
